export default __webpack_public_path__ + "static/media/adp-cover-logo.e9145aef.png";